<template>
  <div
    :class="_.waterfall"
    :style="{
      '--category-color': theme.classifyFontColor,
      '--category-color-active': theme.classifyFocusColor,
      '--category-bgcolor': theme.unCheckedBackgroundColor,
      '--category-bgcolor-active': theme.classifyFocusIconColor,
    }"
  >
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
      <div v-else-if="theme.titleType === 'text'" :class="_.title">
        <div :class="_.primary" :style="{ color: theme.titleFontColor }">
          {{ theme.title }}
        </div>
        <div :class="_.secondary" :style="{ color: theme.subTitleFontColor }">
          {{ theme.subTitle }}
        </div>
      </div>
    </div>
    <div :class="_.bd">
      <div v-if="data.length > 1" :class="_.category">
        <div
          v-for="(item, index) in data"
          :key="index"
          v-track="{
            name: '综合瀑布流-分类栏',
            id: `${componentId}-category`,
            content: item.title,
          }"
          :class="[_.item, categoryIndex === index && _.active]"
          @click="categoryIndex = index"
        >
          {{ item.title }}
        </div>
      </div>
      <dmbc-base-waterfall
        :key="categoryIndex"
        no-complete-tips
        :load="handleDataLoad"
      >
        <template #default="{ data }">
          <dmbc-base-masonry :col-count="2" :gap="7" :class="_.list">
            <dmbc-base-resource
              v-for="(item, index) in data"
              :key="item.id"
              :track="{
                name: '综合瀑布流-商品',
                id: `DianJiZiDingYiYeZiYuan`,
                resource: item,
                index: index,
                extra: getTrackExtra(item, index),
              }"
              :item="item"
            />
          </dmbc-base-masonry>
        </template>
      </dmbc-base-waterfall>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data: () => ({
      categoryIndex: 0,
    }),

    methods: {
      handleDataLoad({ pageNumber }) {
        return this.$dmbcApi.getComponentData({
          id: this.componentId,
          innerId: this.data[this.categoryIndex].id,
          pageIndex: pageNumber,
          pageSize: 10,
          useCdn: this.pageTheme.cdn,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  .waterfall {
    border-radius: var(--border-radius);
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
      }

      .title {
        display: flex;
        align-items: center;

        .primary {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
        }

        .secondary {
          margin-left: 8px;
          font-size: 12px;
          color: #333333;
          line-height: 17px;
        }
      }
    }

    .bd {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);

      .category {
        display: block;
        white-space: nowrap;
        /** 必须同时设置 y 上的，否则 iOS 13 会有拖拽效果 */
        /** 不能用简写形式（overflow: auto hidden），iPhone6s有问题 */
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
        }

        > * {
          display: inline-block;
          white-space: normal;
        }

        .item {
          padding: 5px 12px;
          background: var(--category-bgcolor);
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          color: var(--category-color);
          line-height: 20px;

          + .item {
            margin-left: 10px;
          }

          &.active {
            background: var(--category-bgcolor-active);
            color: var(--category-color-active);
          }
        }
      }

      .list {
        padding-top: 12px;
      }
    }
  }
</style>
